import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase';
import { createStatsData } from '../../utils/createStatsData';
const reportId = 'sales_by_source';
const header = {
    traffic_source: 'Sales by traffic source',
    social_platform: 'Sales by social platform',
};
export const useSalesBySourceReportCard = ({ source }) => {
    const analyticsCardBase = useAnalyticsCardBase({
        reportId,
        filters: { source_dimension: source },
    });
    const data = createStatsData({
        rows: analyticsCardBase.reportData?.report?.rows,
        mapFn: (row) => ({
            label: row.source,
            value: row.total_sales.value,
        }),
    });
    return {
        ...analyticsCardBase,
        type: 'barStats',
        header: {
            label: header[source],
            tooltip: analyticsCardBase.activeColumn?.tooltip,
        },
        data,
    };
};
